<template>
  <DefaultLayout>
    <ProductPageHeroBanner productType="petinsurance" />
    <DynamicProductPage productType="petinsurance" />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import ProductPageHeroBanner from '../../components/products/ProductPageHeroBanner.vue';
import DynamicProductPage from '../DynamicProductPage.vue';

export default {
  name: 'PetInsurancePage',
  components: {
    DefaultLayout,
    ProductPageHeroBanner,
    DynamicProductPage,
  }
};
</script> 